import styles from './Logout.module.css'

export function Logout() {
  return (
    <div className={styles.root}>
      <div className={styles.emoji}>👋</div>
    </div>
  )
}
